module.exports = __webpack_public_path__ + "img/et.6c1bd7db.svg";